import { render, staticRenderFns } from "./ActionsBtnForForm.vue?vue&type=template&id=0d10b2f8&"
import script from "./ActionsBtnForForm.vue?vue&type=script&lang=js&"
export * from "./ActionsBtnForForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports